const COORDINATE_MATCH_EPSILON = 0.0001;

const osmKey = (gym) => {
  if (typeof gym?.osm_key === 'string' && gym.osm_key.trim()) {
    return gym.osm_key.trim().toLowerCase();
  }
  const type = String(gym?.osm_type || '').trim().toLowerCase();
  const id = String(gym?.osm_id || '').trim();
  return type && id ? `${type}:${id}` : null;
};

export const gymsRepresentSamePlace = (savedGym, candidateGym) => {
  const savedOsmKey = osmKey(savedGym);
  const candidateOsmKey = osmKey(candidateGym);
  if (savedOsmKey && candidateOsmKey) return savedOsmKey === candidateOsmKey;

  const savedLatitude = Number(savedGym?.latitude);
  const savedLongitude = Number(savedGym?.longitude);
  const candidateLatitude = Number(candidateGym?.latitude);
  const candidateLongitude = Number(candidateGym?.longitude);
  if (![savedLatitude, savedLongitude, candidateLatitude, candidateLongitude].every(Number.isFinite)) {
    return false;
  }

  return Math.abs(savedLatitude - candidateLatitude) < COORDINATE_MATCH_EPSILON
    && Math.abs(savedLongitude - candidateLongitude) < COORDINATE_MATCH_EPSILON;
};
